import api from "../../../api/axios";

// Feature-local wrappers for the Company invitation creation workflow.
//
// Endpoints (per backend/app/apps/company/urls.py — mounted at API root):
//   GET  /api/companies/{company_id}/                  — CompanyViewSet.retrieve
//        Returns CompanyDetailSerializer payload including `my_role`
//        ("owner" | "admin" | "member" | null). Used by the screen-
//        level permission gate (see screens/companyInvitations).
//   POST /api/companies/{company_id}/invitations/      — CompanyInvitationListCreateView.post
//        Body: { email, role, message?, expires_at? }. Returns the
//        full CompanyInvitationSerializer payload. 403 if not admin;
//        400 with field errors for validation; 400 with
//        non_field_errors for cooldown / unique-pending collisions.
//
// No service layer. No orchestration helpers. No retry. No queue.

export const loadCompany = (companyId) =>
  api.get(`/companies/${companyId}/`).then((res) => res.data);

export const createInvitation = (companyId, body) =>
  api.post(`/companies/${companyId}/invitations/`, body).then((res) => res.data);
